<template>
  <div>
    <div class="list" v-for="(item, index) in list" :key="index">
      <h4 class="collapsible" :class="{ active: item.isShow }" @click="item.isShow = !item.isShow">
        <div :class="{ error: item.hasError }">
          <span class="required" v-if="item.isRequire">*</span>
          {{ `${index + 1}. ${item.formName}` }}
        </div>
      </h4>
      <div class="content" :class="{ active: item.isShow }">
        <ul class="list-task">
          <li
            v-for="(task, index2) in item.taskInFormList"
            :key="(index + 1) * (index2 + 1)"
            :class="{ 'has-image': task.isImageRequire }"
          >
            <div>
              <label style="display: flex">
                <input
                  type="checkbox"
                  v-model="task.isCheck"
                  :disabled="disabled"
                  @change="setOnchange"
                /><span>{{
                  `${task.taskInFormName} ${disabled && task.isImageRequire && task.requireImageAmount ? `(cần ít nhất ${task.requireImageAmount} ảnh)` : ''}`
                }}</span>
              </label>
            </div>
            <template v-if="!disabled">
              <template v-if="task.isImageRequire">
                <UploadOneOrMultip
                  :maxFile="100"
                  titleTag="h2"
                  :uploadToApi="false"
                  :isDragging="true"
                  titleClass="form-inner-heading"
                  :disabled="!task.isCheck"
                  :ref="el => setRefUpload(task, el)"
                  @change="setOnchange"
                />
              </template>
            </template>
            <template v-else>
              <div v-if="task.isImageRequire" class="no-data mb-2">Không có ảnh</div>
            </template>
          </li>
          <li class="no-data" v-show="!item.taskInFormList?.length">Không có dữ liệu</li>
        </ul>
      </div>
    </div>
    <ShowImage ref="showImageRef" />
  </div>
</template>

<script>
  /* list format
{
  id: {
    timestamp: number;
    date: string;
  };
  applyLevel: "STORE";
  formCode: string;
  formName: string;
  taskInFormList: {
    formCode: string;
    taskInFormName: string;
    taskInFormCode: string;
  }[];
}[]
*/
  import { nextTick } from 'vue'
  import ShowImage from './ShowImage.vue'
  import UploadOneOrMultip from '@/components/cskh/UploadOneOrMultip.vue'
  import { showMess } from '@/config/utils'

  export default {
    name: 'SupportInfo',
    props: {
      // list: {
      //   type: Object,
      //   required: true,
      //   default: () => {
      //     return []
      //   }
      // },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      ShowImage,
      UploadOneOrMultip,
    },
    data() {
      return {
        list: [],
        uploadRefs: {},
      }
    },
    methods: {
      setRefUpload(task, el) {
        if (!this.uploadRefs[task.taskInFormCode]) {
          this.uploadRefs[task.taskInFormCode] = el

          nextTick(() => {
            el.setData(
              (task.images || []).map(url => {
                return {
                  url: url,
                  location: '',
                  type: 'images',
                  uploaded: true,
                }
              })
            )
          })
        }
      },

      validate() {
        for (const category of this.list) {
          category.hasError = false
          const isRequire = category.isRequire
          let hasCheck = false
          for (const task of category.taskInFormList) {
            if (task.isCheck) {
              hasCheck = true
              if (task.isImageRequire) {
                const uploadRef = this.uploadRefs[task.taskInFormCode]
                if (uploadRef) {
                  const imageData = uploadRef.getData()
                  if (imageData.length < task.requireImageAmount) {
                    category.hasError = true
                  }
                }
              }
            }
          }
          if (isRequire && !hasCheck) {
            category.isShow = true
            category.hasError = true
          }
        }

        return this.list.every(item => !item.hasError)
      },
      async saveData() {
        try {
          for (const category of this.list) {
            for (const task of category.taskInFormList) {
              if (task.isCheck && task.isImageRequire) {
                const uploadRef = this.uploadRefs[task.taskInFormCode]
                if (uploadRef) {
                  await uploadRef.saveData()
                  const imageData = uploadRef.getData()
                  task.images = imageData.map(item => item.url)
                }
              }
            }
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      getData() {
        return this.list
          .filter(item => item.taskInFormList.some(task => task.isCheck))
          .map(item => {
            const { isShow, taskInFormList, ...itemInfo } = item
            return {
              ...itemInfo,
              taskInFormDataList: taskInFormList
                .filter(task => task.isCheck)
                .map(task => {
                  const { isCheck, hasError, ...taskInfo } = task
                  return taskInfo
                }),
            }
          })
      },
      showImg(src) {
        this.$refs.showImageRef?.show(src, 'Ảnh chụp')
      },
      setData(list) {
        this.list = list.map((item, index) => {
          return {
            ...item,
            isShow: false, // index === 0,
            hasError: false,
            taskInFormList: item.taskInFormList.map(task => {
              return {
                ...task,
                isCheck: task.isCheck || false,
              }
            }),
          }
        })
      },

      setValues(mapValue) {
        this.list.forEach(item => {
          item.taskInFormList.forEach(task => {
            task.isCheck = !!mapValue[`${task.formCode}|${task.taskInFormCode}`]
            task.images = mapValue[`${task.formCode}|${task.taskInFormCode}`]?.images || []
          })
        })
      },
      setOnchange() {
        this.$emit('change')
      },
    },
  }
</script>

<style scoped lang="scss">
  .list {
    & + .list {
      border-top: 1px solid #ddd;
    }
  }
  h4 {
    &.collapsible {
      color: black;
      cursor: pointer;
      padding: 10px;
      width: 100%;
      border: none;
      text-align: left;
      outline: none;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0;

      .error {
        color: red;
      }

      &::after {
        content: '▼';
        font-size: 13px;
        color: #999;
        margin-left: 5px;
      }
      &.active::after {
        content: '▲' !important;
      }
      &:hover {
        background-color: #eee;
      }
    }

    .required {
      color: red;
      margin-right: 2px;
    }
  }

  .content {
    padding: 6px 18px;
    display: none;
    overflow: hidden;
  }

  .contentul {
    list-style-type: none;
    padding-left: 20px;
  }

  .active {
    display: block;
  }

  ul.list-task {
    padding-left: 0;
    list-style-type: none;
    li {
      // display: flex;
      // align-items: center;
      span {
        margin-left: 10px;
      }

      &.no-data {
        color: #ddd;
        justify-content: center;
      }

      .list-images {
        margin-left: 15px;
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;
        .image-item {
          & + .image-item {
            margin-left: 10px;
          }
          height: 80px;
          display: inline-flex;
          overflow-y: hidden;
          .image {
          }
        }
      }
      .no-data {
        text-align: center;
        color: #ddd;
      }

      & + li.has-image {
        margin-top: 15px;
      }
    }
  }
</style>
